import { render, staticRenderFns } from "./PermissionDataRuleList.vue?vue&type=template&id=e8e5946e"
import script from "./PermissionDataRuleList.vue?vue&type=script&lang=js"
export * from "./PermissionDataRuleList.vue?vue&type=script&lang=js"
import style0 from "./PermissionDataRuleList.vue?vue&type=style&index=0&id=e8e5946e&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8e5946e')) {
      api.createRecord('e8e5946e', component.options)
    } else {
      api.reload('e8e5946e', component.options)
    }
    module.hot.accept("./PermissionDataRuleList.vue?vue&type=template&id=e8e5946e", function () {
      api.rerender('e8e5946e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/PermissionDataRuleList.vue"
export default component.exports